import { BePlannedPageV2 } from "./BeplannedV2";

export default BePlannedPageV2;
